export default __webpack_public_path__ + "static/media/GuidePointImg.eea1be92.png";